module.exports = __webpack_public_path__ + "static/background-deb23f4f25c02b6466a57c34209cf865.png";